import { ShoppingCartCheckout as OrderIcon } from "@mui/icons-material";
import { Grid, Tooltip, Typography } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import type { NoteDTO } from "../../api/api";
import type { UserRole } from "../auth/auth";
import CustomerLink from "../components/customerLink/CustomerLink";
import EntityCard from "../components/entityCard/EntityCard";
import { LastNotes } from "../components/entityCard/LastNotes";
import SimpleNotes from "../components/notes/SimpleNotes";
import type { ListCalculationsResponseItemWithCustomer } from "./useCalculations";

interface Props {
  readonly value: ListCalculationsResponseItemWithCustomer;
  readonly role: UserRole | undefined;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
  readonly onUpdateNotes: (notes: NoteDTO[]) => void;
}

const CalculationCard: FC<Props> = ({ value, role, onClick, onContextMenu, onUpdateNotes }) => {
  const navigate = useNavigate();

  const isAdminOrAgent = role === "ADMIN" || role === "AGENT";
  return (
    <EntityCard
      role={role}
      onClick={onClick}
      onContextMenu={onContextMenu}
      rightHandSideComponent={<LastNotes notes={value.notes ?? []} />}
      rightHandSideComponentExpandable
      expandableComponent={<SimpleNotes notes={value.notes ?? []} onChange={onUpdateNotes} />}
    >
      <Grid size={4}>
        <Typography variant="subtitle1">{value.name}</Typography>
      </Grid>
      {isAdminOrAgent && (
        <Grid size={4}>
          <CustomerLink customerId={value.customer.id} color="inherit" underline="hover">
            {value.customer.name ?? ""}
          </CustomerLink>
        </Grid>
      )}
      <Grid size={2}>
        <Typography>{value.startDate}</Typography>
      </Grid>
      {value.orderId && (
        <Grid size={2}>
          <Tooltip title="Zamówienie zostało złożone">
            <OrderIcon
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/orders/${value.orderId}`);
              }}
            />
          </Tooltip>
        </Grid>
      )}
    </EntityCard>
  );
};

export default CalculationCard;
